<template lang="pug">
v-container.justify-center.mt-md-4.mb-16.page-product
  .py-10.d-flex.justify-center(v-if="loading")
    v-progress-circular(size="50", color="primary", indeterminate)
  template(v-else)
    .text-h6.text-sm-h5.font-weight-bold.mb-3
      span.primary--text {{ product.title }} |
      span.ml-2.text--secondary {{ product.category.title }}
    grid-container(cols="auto", cols-md="max-content auto", gap="20px")
      product-gallery-widget(
        v-if="product.img.list",
        :items="product.img.list",
        :main="product.img.featured"
      )
      div
        .ck-content.mb-8(v-html="product.text")
        div
          v-btn.mt-3.py-6(
            :href="whatsappLink",
            target="_blank",
            color="primary",
            width="265px",
            tile,
            depressed
          )
            v-icon(left) fab fa-whatsapp
            span.font-weight-bold.poppins SOLICITAR ORÇAMENTO
</template>

<script>
import CustomTitle from "@/components/shell/CustomTitle.vue";
import ProductGalleryWidget from "@/components/widgets/ProductGallery.vue";
import { getWhatsappLinkFromPhone } from "@/components/utils.js";

const _config = {
  mod: "products",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    productId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    product() {
      return this.$rest(_config.mod).item;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    whatsappLink() {
      const tel = this.$rest("informations").item.whatsapp;

      if (!tel) return;

      const link = getWhatsappLinkFromPhone(tel);

      const { title } = this.product;

      let text = `Olá! Gostaria de um orçamento do *${title}:*.`;

      return `${link}?text=${encodeURIComponent(text)}`;
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(date)
      );
    },
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.productId })
        .then(() => (this.loading = false))
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    productId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    CustomTitle,
    ProductGalleryWidget,
  },
};
</script>
